import styled from "styled-components";

import { StyledChipBase } from "@/styles/styled";

export const StyledProfileHeader = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const StyledProfileName = styled.span`
    color: var(--color-grey-900);
    font-size: var(--size-24);
    margin: 5px 0;
    word-break: break-word;
    text-align: center;
`;

export const StyledPolicyholderChip = styled(StyledChipBase)`
    color: var(--color-grey-900);
    margin: 5px 0;
    background: var(--color-tertiary);
`;

export const StyledDateActive = styled.span`
    color: var(--color-grey-900);
    font-size: var(--size-14);
    margin: 5px 0;
`;
